import { Container } from '@material-ui/core';
import { PricingPlanProvider } from 'context/PricingPlanContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SignInForm from '../../../components/form/auth/sign-in';
import { useStyle } from './sign-in.style';

export const SignIn: React.FC = () => {
    const classes = useStyle();
    const { t } = useTranslation();

    return (
        <PricingPlanProvider>
            <Container component="main" maxWidth={false} className={classes.container}>
                <div className={classes.paper}>
                    <div className={classes.logoContainer}>
                        <img src={require('assets/logo-white.svg')} className={classes.logo} alt={t('signIn:logo')} />
                    </div>
                </div>
                <SignInForm />
            </Container>
        </PricingPlanProvider>
    );
};
